import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getHotMovies, formatViews } from '@/utils/movie';
import SectionHeader from '@/components/feature/SectionHeader';

const hotList = getHotMovies(8);

export default function PopularList() {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = hotList[activeIndex];

  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <SectionHeader
        title="热门影视推荐"
        subtitle="依据播放量模拟数据排序，大家都爱看"
        icon="ri-fire-line"
        moreTo="/category/hot"
      />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
        <div className="lg:col-span-7 flex flex-col">
          {hotList.map((movie, index) => (
            <button
              key={movie.id}
              type="button"
              onMouseEnter={() => setActiveIndex(index)}
              onClick={() => setActiveIndex(index)}
              className={`group flex items-center gap-3 md:gap-4 p-3 rounded-lg text-left cursor-pointer transition-colors ${
                index === activeIndex ? 'bg-background-100' : 'hover:bg-background-100/60'
              }`}
            >
              <span
                className={`font-label text-2xl md:text-3xl w-8 text-center shrink-0 ${
                  index < 3 ? 'text-accent-500' : 'text-foreground-400'
                }`}
              >
                {String(index + 1).padStart(2, '0')}
              </span>
              <img
                src={movie.cover}
                alt={`${movie.title} 封面`}
                title={`${movie.title} - 亚洲中文字幕在线观看`}
                className="w-12 h-16 md:w-14 md:h-20 rounded-md object-cover object-top shrink-0"
              />
              <div className="min-w-0 flex-1">
                <h3 className="text-sm md:text-base font-medium text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
                  {movie.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 truncate">
                  {movie.region} · {movie.year} · {movie.genres.join('/')}
                </p>
                <p className="mt-1 text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-fire-line text-accent-500"></i>
                  {formatViews(movie.views)} 次播放
                </p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors shrink-0"></i>
            </button>
          ))}
        </div>

        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-20 rounded-lg overflow-hidden bg-background-100 border border-background-200">
            <div className="relative w-full h-56 md:h-64">
              <img
                src={active.backdrop || active.cover}
                alt={`${active.title} 预览`}
                title={`${active.title} - 亚洲中文字幕在线观看`}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-background-950/40 to-transparent"></div>
              <span className="absolute top-3 left-3 px-2 h-6 flex items-center rounded-md bg-accent-500 text-background-50 text-xs font-label tracking-wide">
                TOP {activeIndex + 1}
              </span>
            </div>
            <div className="p-5">
              <h3 className="font-heading font-bold text-xl text-foreground-950">{active.title}</h3>
              <p className="mt-1 text-xs text-foreground-500">
                {active.region} · {active.year} · {active.duration} · 评分 {active.rating.toFixed(1)}
              </p>
              <p className="mt-3 text-sm text-foreground-600 leading-7 line-clamp-3">{active.synopsis}</p>
              <div className="mt-3 flex flex-wrap gap-2">
                {active.genres.map((genre) => (
                  <span
                    key={genre}
                    className="px-2.5 h-6 flex items-center rounded-md bg-secondary-900 text-secondary-200 text-xs"
                  >
                    {genre}
                  </span>
                ))}
              </div>
              <Link
                to={`/detail/${active.id}`}
                className="mt-5 inline-flex items-center gap-2 px-5 h-10 rounded-md bg-primary-500 text-background-950 text-sm font-medium hover:bg-primary-600 cursor-pointer whitespace-nowrap transition-colors"
              >
                <i className="ri-play-circle-line text-lg"></i>
                查看详情
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}